<form [formGroup]="formGroup" class="walk-test">
  @if (pageTitle) {
    <div class="walk-test-page-header">
      <b>{{ getQuestionTitle(pageTitle) }}</b>
      @if (getQuestionInstruction(pageTitle)) {
        <div class="walk-test-instruction">
          {{ getQuestionInstruction(pageTitle) }}
        </div>
      }
    </div>
  }
  @for (element of elements; track element.name) {
    @if (element.type === "text") {
      <div class="walk-test-row" [class.walk-test-locked]="isLocked(element)">
        <div class="walk-test-q">
          <div class="walk-test-q-title">
            {{ getQuestionTitle(element.title) }}
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="walk-test-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>
        <div>
          <input
            type="text"
            class="walk-test-input"
            [attr.inputmode]="isDistanceElement(element) ? 'numeric' : null"
            [attr.maxlength]="isDistanceElement(element) ? 4 : null"
            [formControlName]="element.name"
          />
          @if (isInvalid(element)) {
            <div class="walk-test-error">
              {{ "Enter a whole number from 0 to 1000" | translate }}
            </div>
          }
        </div>
      </div>
    }
    @if (element.type === "radiogroup") {
      <div class="walk-test-row">
        <div class="walk-test-q">
          <div class="walk-test-q-title">
            {{ getQuestionTitle(element.title) }}
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="walk-test-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>
        <div class="walk-test-group">
          @for (choice of element.choices; track choice.value) {
            <label class="walk-test-option">
              <input
                type="radio"
                [formControlName]="element.name"
                [value]="choice.value"
                (click)="onRadioClick(element.name, choice.value)"
              />
              <span>{{ choice.text }}</span>
            </label>
          }
        </div>
      </div>
    }
  }
</form>
